import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContentBefore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 235 100",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "axis",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "matrix(1.0051,0,0,1.0051,-146.214,-284.005)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M159.92,350.334L363.949,350.334",
					style: {
						fill: "none",
						stroke: "black",
						strokeOpacity: .05,
						strokeWidth: "0.99px"
					}
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-877.16,-66.597)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(13,0,0,13,1095.64,150.104)" }), /* @__PURE__ */ _jsxs("text", {
					x: "1059.3px",
					y: "150.104px",
					style: {
						fontFamily: "'Aileron-Regular', 'Aileron'",
						fontSize: 13,
						fill: "rgb(183,183,183)"
					},
					children: [
						"T",
						/* @__PURE__ */ _jsx("tspan", {
							x: "1066.45px ",
							y: "150.104px ",
							children: "o"
						}),
						"day"
					]
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-989.296,-104.452)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(13,0,0,13,1074.72,186.377)" }), /* @__PURE__ */ _jsx("text", {
					x: "1003.97px",
					y: "186.377px",
					style: {
						fontFamily: "'Aileron-Regular', 'Aileron'",
						fontSize: 13,
						fill: "rgb(183,183,183)"
					},
					children: "90 days ago"
				})]
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		id: "content-BEFORE",
		transform: "matrix(1,0,0,1,-0.464732,6.40587)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "content_1",
				transform: "matrix(1,0,0,1,-454.933,-215.624)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M473.418,245.7C473.418,245.7 500.139,246.471 531.907,251.54",
					style: {
						fill: "none",
						stroke: "rgb(255,152,0)",
						strokeWidth: "2.5px"
					}
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "content_2",
				transform: "matrix(2.12064,0,0,1,-1051.07,-215.624)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M531.965,251.549C542.956,253.904 553.087,255.501 560.754,256.349C574.489,257.869 589.759,257.751 597.334,258.275",
					style: {
						fill: "none",
						stroke: "rgb(255,152,0)",
						strokeWidth: "2.5px"
					}
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "matrix(1,0,0,1,-457.933,-227.624)",
				children: [/* @__PURE__ */ _jsx("g", { transform: "matrix(15,0,0,15,677.619,262.41)" }), /* @__PURE__ */ _jsxs("text", {
					x: "642.594px",
					y: "262.41px",
					style: {
						fontFamily: "'Aileron-Black', 'Aileron'",
						fontWeight: 900,
						fontSize: 15,
						fill: "rgb(255,152,0)"
					},
					children: ["F", /* @__PURE__ */ _jsx("tspan", {
						x: "651.624px 662.454px 667.389px ",
						y: "262.41px 262.41px 262.41px ",
						children: "AIR"
					})]
				})]
			})
		]
	})]
});
export default SvgContentBefore;
